import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="mx-auto flex min-h-[70vh] max-w-[1400px] flex-col items-center justify-center px-4 py-20 text-center md:px-6">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-200/60 text-foreground-500">
        <i className="ri-film-line text-3xl"></i>
      </span>
      <p className="mt-6 font-heading text-6xl font-black text-background-300 md:text-8xl">404</p>
      <h1 className="mt-4 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
        这个页面好像走丢了
      </h1>
      <p className="mt-2 max-w-md text-sm text-foreground-500">
        你要找的页面不存在或已被移除，返回首页继续探索精彩影视吧。
      </p>
      <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
        >
          返回首页
        </Link>
        <Link
          to="/movies"
          className="rounded-md border border-background-200/70 px-5 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-500"
        >
          浏览电影
        </Link>
      </div>
    </div>
  );
}